import React, {useEffect, useState} from 'react';
import {Form} from "react-bootstrap";
import {searchArtist} from "../../api/spotify-helper";

export default function Search() {

    const [options, setOptions] = useState([]);
    const MIN_WORD_NUMBER = 2;
    const RESULT_LIMIT = 5;

    useEffect(() => {
        const $search = document.querySelector('#search');

        $search.addEventListener("input", (e) => {
            $search.value.length >= MIN_WORD_NUMBER ?
                searchArtist($search.value, RESULT_LIMIT).then(data => {
                    setOptions(data.artists.items);
                }) :
                setOptions([]);
        });
    }, [])

    function selectOptionOnClick(optionSelected) {
        const $search = document.querySelector('#search');
        const $button = document.querySelector('form button');
        $search.value = optionSelected.name;
        $search.setAttribute('data-selected-id', optionSelected.id);
        $button.classList.remove('disabled');
        setOptions([]);
    }

    function onSearch(e) {
        e.preventDefault();
        const $search = document.querySelector('#search');

        // @todo: add id on submit if not already done
        if ($search.getAttribute('data-selected-id')) {
            const artistId = $search.getAttribute('data-selected-id');
            window.location = `${window.location.origin}/?page=dashboard&artist=${artistId}`;
        }
    }

    return (
        <div className="search-bar-container">
            <Form role="search" onSubmit={(e) => onSearch(e)}>
                <input id="search" type="search" autoComplete="off" placeholder="Rechercher un artiste" autoFocus required/>
                <button type="submit" className={"disabled"}>
                    <i className={"fas fa-search"}></i>
                </button>
                {(options.length > 0) && (
                    <ul className={'optionsPanel'}>
                        {options.map((option, i) => {
                            return <li key={i} data-id={option.id} onClick={() => selectOptionOnClick(option) }>{option.name}</li>
                        })}
                    </ul>
                )}
            </Form>
        </div>
    )
}